export const featured = {
    id: 0,
    author: "OSCAR ANTONIO HINOJOSA SALUM",
    desc: "THE FATHER OF ALCARODIA",
    img: "images/author/Ca.webp",
    socials: [
        ["images/author/icons/github.svg", "https://github.com/Caferino"],
        ["images/author/icons/linkedin.svg", "https://www.linkedin.com/in/caferino/"],
        ["images/author/icons/code.svg", "https://www.codecademy.com/profiles/Caferino"],
        ["images/author/icons/leetcode.svg", "https://leetcode.com/u/caferinograalb/"],
        ["images/author/icons/codewars.svg", "https://www.codewars.com/users/Caferino"],
        ["images/author/icons/kindle.svg", "https://www.amazon.com/stores/%C3%93scar-Antonio-Hinojosa-Salum/author/B0BYX6RXTQ?isDramIntegrated=true&shoppingPortalEnabled=true"],
        ["images/author/icons/steam.svg", "https://steamcommunity.com/profiles/76561198066126429"],
        ["images/author/icons/xbox.svg", "https://www.xbox.com/es-MX/play/user/Caferino2164"],
        ["images/author/icons/ow.svg", "https://overwatch.blizzard.com/en-us/career/d15faa8fa17895a2a4a126a3d407%7Ccf36cdbc5554cad7f964de0bef49b0d7/"],
        ["images/author/icons/wow.svg", "https://worldofwarcraft.blizzard.com/en-us/character/us/area-52/caferino/"],
        ["images/author/icons/rockstar.svg", "https://socialclub.rockstargames.com/member/CAFERINO/games"],
        ["images/author/icons/rs.svg", "https://apps.runescape.com/runemetrics/app/overview/player/calflex"],
        ["images/author/icons/osrs.svg", "https://www.runeprofile.com/doroteoodeon"],
    ]
}

export const videogames = [
    {
        id: 1,
        img: "images/author/videogames/ow.webp"
    },
    {
        id: 2,
        img: "images/author/videogames/wow.webp"
    },
    {
        id: 3,
        img: "images/author/videogames/rdr2.webp"
    },
    {
        id: 4,
        img: "images/author/videogames/mc.webp"
    },
    {
        id: 5,
        img: "images/author/videogames/ft.webp"
    },
    {
        id: 6,
        img: "images/author/videogames/rs.webp"
    },
    {
        id: 7,
        img: "images/author/videogames/tibia.webp"
    },
    {
        id: 8,
        img: "images/author/videogames/tlou.webp"
    },
    {
        id: 9,
        img: "images/author/videogames/ssb.webp"
    },
    {
        id: 10,
        img: "images/author/videogames/rimworld.webp"
    },
    {
        id: 11,
        img: "images/author/videogames/gtav.webp"
    },
    {
        id: 12,
        img: "images/author/videogames/elden ring.webp"
    },
    {
        id: 13,
        img: "images/author/videogames/re2.webp"
    },
    {
        id: 14,
        img: "images/author/videogames/pt.webp"
    },
];

export const movies = [
    {
        id: 1,
        img: "images/author/movies/batman.webp"
    },
    {
        id: 2,
        img: "images/author/movies/lotr.webp"
    },
    {
        id: 3,
        img: "images/author/movies/idiots.webp"
    },
    {
        id: 4,
        img: "images/author/movies/avengers.webp"
    },
    {
        id: 5,
        img: "images/author/movies/joker.webp"
    },
    {
        id: 6,
        img: "images/author/movies/alien.webp"
    },
    {
        id: 7,
        img: "images/author/movies/rrr.webp"
    },
    {
        id: 8,
        img: "images/author/movies/god.webp"
    },
    {
        id: 9,
        img: "images/author/movies/country.webp"
    },
    {
        id: 10,
        img: "images/author/movies/madmax.webp"
    },
    {
        id: 11,
        img: "images/author/movies/network.webp"
    },
    {
        id: 12,
        img: "images/author/movies/watchmen.webp"
    },
    {
        id: 13,
        img: "images/author/movies/blood.webp"
    },
    {
        id: 14,
        img: "images/author/movies/interstellar.webp"
    },
];

export const anime_movies = [
    {
        id: 1,
        img: "images/author/anime movies/spirited.webp"
    },
    {
        id: 2,
        img: "images/author/anime movies/name.webp"
    },
    {
        id: 3,
        img: "images/author/anime movies/akira.webp"
    },
    {
        id: 4,
        img: "images/author/anime movies/grave.webp"
    },
    {
        id: 5,
        img: "images/author/anime movies/pokemon.webp"
    },
    {
        id: 6,
        img: "images/author/anime movies/ghost.webp"
    },
    {
        id: 7,
        img: "images/author/anime movies/princess.webp"
    },
    {
        id: 8,
        img: "images/author/anime movies/paprika.webp"
    },
    {
        id: 9,
        img: "images/author/anime movies/blue.webp"
    },
    {
        id: 10,
        img: "images/author/anime movies/broly.webp"
    },
    {
        id: 11,
        img: "images/author/anime movies/redline.webp"
    },
    {
        id: 12,
        img: "images/author/anime movies/evangelion.webp"
    },
    {
        id: 13,
        img: "images/author/anime movies/jujutsu.webp"
    },
    {
        id: 14,
        img: "images/author/anime movies/howl.webp"
    },
];

export const animated_movies = [
    {
        id: 1,
        img: "images/author/animated movies/shrek.webp"
    },
    {
        id: 2,
        img: "images/author/animated movies/toy.webp"
    },
    {
        id: 3,
        img: "images/author/animated movies/spongebob.webp"
    },
    {
        id: 4,
        img: "images/author/animated movies/inside.webp"
    },
    {
        id: 5,
        img: "images/author/animated movies/pinocchio.webp"
    },
    {
        id: 6,
        img: "images/author/animated movies/walle.webp"
    },
    {
        id: 7,
        img: "images/author/animated movies/monsters inc.webp"
    },
    {
        id: 8,
        img: "images/author/animated movies/iron.webp"
    },
    {
        id: 9,
        img: "images/author/animated movies/ratatouille.webp"
    },
    {
        id: 10,
        img: "images/author/animated movies/tarzan.webp"
    },
    {
        id: 11,
        img: "images/author/animated movies/dinosaur.webp"
    },
    {
        id: 12,
        img: "images/author/animated movies/atlantis.webp"
    },
    {
        id: 13,
        img: "images/author/animated movies/emperor.webp"
    },
    {
        id: 14,
        img: "images/author/animated movies/antz.webp"
    },
];

export const tv = [
    {
        id: 1,
        img: "images/author/tv/bcs.webp"
    },
    {
        id: 2,
        img: "images/author/tv/mr.webp"
    },
    {
        id: 3,
        img: "images/author/tv/wire.webp"
    },
    {
        id: 4,
        img: "images/author/tv/chernobyl.webp"
    },
    {
        id: 5,
        img: "images/author/tv/shogun.webp"
    },
    {
        id: 6,
        img: "images/author/tv/mindhunter.webp"
    },
    {
        id: 7,
        img: "images/author/tv/men.webp"
    },
    {
        id: 8,
        img: "images/author/tv/boys.webp"
    },
    {
        id: 9,
        img: "images/author/tv/trailer.webp"
    },
    {
        id: 10,
        img: "images/author/tv/black.webp"
    },
    {
        id: 11,
        img: "images/author/tv/narcos.webp"
    },
    {
        id: 12,
        img: "images/author/tv/fargo.webp"
    },
    {
        id: 13,
        img: "images/author/tv/seinfeld.webp"
    },
    {
        id: 14,
        img: "images/author/tv/office.webp"
    },
];

export const anime = [
    {
        id: 1,
        img: "images/author/anime/aot.webp"
    },
    {
        id: 2,
        img: "images/author/anime/jujutsu.webp"
    },
    {
        id: 3,
        img: "images/author/anime/evangelion.webp"
    },
    {
        id: 4,
        img: "images/author/anime/dragon.webp"
    },
    {
        id: 5,
        img: "images/author/anime/naruto.webp"
    },
    {
        id: 6,
        img: "images/author/anime/psycho.webp"
    },
    {
        id: 7,
        img: "images/author/anime/berserk.webp"
    },
    {
        id: 8,
        img: "images/author/anime/texhnolyze.webp"
    },
    {
        id: 9,
        img: "images/author/anime/opm.webp"
    },
    {
        id: 10,
        img: "images/author/anime/monster.webp"
    },
    {
        id: 11,
        img: "images/author/anime/one.webp"
    },
    {
        id: 12,
        img: "images/author/anime/vinland.webp"
    },
    {
        id: 13,
        img: "images/author/anime/elfen.webp"
    },
    {
        id: 14,
        img: "images/author/anime/baki.webp"
    },
];

export const cartoons = [
    {
        id: 1,
        img: "images/author/cartoons/tom.webp"
    },
    {
        id: 2,
        img: "images/author/cartoons/spongebob.webp"
    },
    {
        id: 3,
        img: "images/author/cartoons/smiling.webp"
    },
    {
        id: 4,
        img: "images/author/cartoons/rick.webp"
    },
    {
        id: 5,
        img: "images/author/cartoons/simpsons.webp"
    },
    {
        id: 6,
        img: "images/author/cartoons/south.webp"
    },
    {
        id: 7,
        img: "images/author/cartoons/futurama.webp"
    },
    {
        id: 8,
        img: "images/author/cartoons/invincible.webp"
    },
    {
        id: 9,
        img: "images/author/cartoons/archer.webp"
    },
    {
        id: 10,
        img: "images/author/cartoons/venture.webp"
    },
    {
        id: 11,
        img: "images/author/cartoons/avatar.webp"
    },
    {
        id: 12,
        img: "images/author/cartoons/boondocks.webp"
    },
    {
        id: 13,
        img: "images/author/cartoons/bojack.webp"
    },
    {
        id: 14,
        img: "images/author/cartoons/edgerunners.webp"
    },
];

/*  author entry template, (edit id and everything else):
{
    id: ###,
    img: "images/author/test.webp"
},
*/